import {configureStore as rtkConfigureStore} from '@reduxjs/toolkit'
import {createEpicMiddleware} from 'redux-observable'
import epics from 'epics'
import rootReducers from 'reducers'
import {isDevelopmentEnv} from 'utils'
import history from 'browserHistory'
import errorHandler from './middleware/errorHandler'
import trimFields from './middleware/trimFields'
import {persistSelectedOffices} from './middleware/persistSelectedOffices'
import {createEarlyFetchDestroyDetector, LOCATION_CHANGE} from './middleware/earlyFetchDestroyDetector'

const epicMiddleware = createEpicMiddleware()
let middleware = [errorHandler, epicMiddleware, trimFields, persistSelectedOffices, createEarlyFetchDestroyDetector()]

export function configureStore(initialState) {
  const store = rtkConfigureStore({
    reducer: rootReducers,
    preloadedState: initialState,
    devTools: isDevelopmentEnv,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({immutableCheck: false, serializableCheck: false}).concat(middleware),
  })
  history.listen((location) => {
    store.dispatch({type: LOCATION_CHANGE, payload: {location}})
  })
  epicMiddleware.run(epics)
  if (import.meta.webpackHot) {
    import.meta.webpackHot.accept('reducers', async () => {
      const {default: nextRootReducer} = await import('reducers')
      store.replaceReducer(nextRootReducer)
    })
  }
  return store
}
